import { AlertTriangle, RotateCw, WifiOff, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

// ── Error overlay (video failed after retries) ─────────────────────────

interface VideoStatusOverlayProps {
  hasError: boolean;
  onRetry: () => void;
}

export function VideoStatusOverlay({
  hasError,
  onRetry,
}: VideoStatusOverlayProps) {
  const { t } = useTranslation();

  if (!hasError) return null;

  return (
    <div className="absolute inset-0 z-[4] flex flex-col items-center justify-center gap-3 bg-black/75 p-6 text-center">
      <AlertTriangle size={36} className="text-white" />

      <span className="text-base font-semibold text-white">
        {t('video_player.load_error')}
      </span>

      <button
        onClick={onRetry}
        className="flex cursor-pointer items-center gap-2 rounded-full border border-white/30 bg-white/10 px-4 py-2 text-sm text-white hover:bg-white/20"
      >
        <RotateCw size={16} />
        {t('video_player.tap_to_retry')}
      </button>
    </div>
  );
}

// ── Slow network hint (shown under spinner while still loading) ─────────

interface SlowNetworkHintProps {
  onDismiss: () => void;
}

export function SlowNetworkHint({ onDismiss }: SlowNetworkHintProps) {
  const { t } = useTranslation();

  return (
    <>
      <WifiOff size={24} className="text-white/80" />

      <span className="text-sm font-medium text-white">
        {t('video_player.slow_network')}
      </span>

      <span className="text-xs text-white/60">
        {t('video_player.slow_network_hint')}
      </span>

      <button
        onClick={onDismiss}
        aria-label={t('video_player.slow_network_dismiss')}
        className="mt-1 cursor-pointer border-none bg-transparent text-xs text-white/50 underline hover:text-white/80"
      >
        {t('video_player.slow_network_dismiss')}
      </button>
    </>
  );
}
